module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Pink - Selected.9f0578cc.png";